/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BidManagementEditOrderRequest } from '../models/BidManagementEditOrderRequest';
import type { BidManagementEditOrderResponseApiRespoonse } from '../models/BidManagementEditOrderResponseApiRespoonse';
import type { BidManagementExportOrderRequest } from '../models/BidManagementExportOrderRequest';
import type { BidManagementExportOrderResponseApiRespoonse } from '../models/BidManagementExportOrderResponseApiRespoonse';
import type { BidManagementListOrderRequest } from '../models/BidManagementListOrderRequest';
import type { BidManagementListOrderResponseApiRespoonse } from '../models/BidManagementListOrderResponseApiRespoonse';
import type { BidManagementOutputOrderCsvRequest } from '../models/BidManagementOutputOrderCsvRequest';
import type { BidManagementShowOrderRequest } from '../models/BidManagementShowOrderRequest';
import type { BidManagementShowOrderResponseApiRespoonse } from '../models/BidManagementShowOrderResponseApiRespoonse';
import type { HttpFoundationStreamedResponseApiRespoonse } from '../models/HttpFoundationStreamedResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidManagementBidService {

    /**
     * 落札鯉一覧
     * @param requestBody
     * @returns BidManagementListOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminBid(
        requestBody: BidManagementListOrderRequest,
    ): CancelablePromise<BidManagementListOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/bid',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 落札鯉の更新
     * @param requestBody
     * @returns BidManagementEditOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminBidEdit(
        requestBody: BidManagementEditOrderRequest,
    ): CancelablePromise<BidManagementEditOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/bid/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 落札鯉表示
     * @param requestBody
     * @returns BidManagementShowOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminBidShow(
        requestBody: BidManagementShowOrderRequest,
    ): CancelablePromise<BidManagementShowOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/bid/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 落札鯉情報のcsv出力
     * @param requestBody
     * @returns BidManagementExportOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminBidCsv(
        requestBody: BidManagementExportOrderRequest,
    ): CancelablePromise<BidManagementExportOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/bid/csv',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 落札鯉情報のcsv出力
     * @param requestBody
     * @returns HttpFoundationStreamedResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminBidCsv1(
        requestBody: BidManagementOutputOrderCsvRequest,
    ): CancelablePromise<HttpFoundationStreamedResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/bid/csv',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
